import { createSelector } from '@reduxjs/toolkit';

const getCurrentLanguageFromStore = (state) => state.language.selectedLang;
const getAllLanguagesfromStore = (state) => state.language.languages;

export const getCurrentLanguage = () =>
  createSelector(
    getCurrentLanguageFromStore,
    getAllLanguagesfromStore,
    (selectedLanguage, languages) => {
      const currentLanguage = languages.find(
        (lang) => lang.code === selectedLanguage
      );

      return currentLanguage;
    }
  );

export const getAllLanguages = () =>
  createSelector(getAllLanguagesfromStore, (allLanguages) => allLanguages);
